// @flow

import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import {
  CLOUDFRONT_STATIC,
  GOALS,
  GUTTER_SIZE,
  ONBOARDING_GOAL_SELECTION_VIEW_NAME,
  SPACING_BASE,
} from '../../../config/constants';
import type { ViewInterface } from '../../AbstractView';
import OnboardingContainer from '../../../components/OnboardingContainer';
import SYHeadlineFour from '../../../components/SYHeadlineFour';
import type { Goal } from '../../../types/Goal';
import SYProgressBar from '../../../components/SYProgressBar';
import GoalCardHead from '../../../components/GoalCardHead';
import SYHeadlineFive from '../../../components/SYHeadlineFive';
import { googleTrackingService } from '../../../services/GoogleTrackingProvider';
import makeImageUrl from '../../../modules/makeImageUrl';
import AbstractView from '../../AbstractView';
import withOnboarding from './withOnboarding';
import type { OnboardingProps } from './withOnboarding';

const GoalSelection = styled(Link)`
  display: block;
  margin: 0 0 ${SPACING_BASE * 2}px;
  padding: ${SPACING_BASE * 12}px ${GUTTER_SIZE}px ${GUTTER_SIZE / 2}px;
  background: url(${(props) => props.image}) no-repeat center / cover;
  cursor: pointer;
  text-decoration: none;
  outline: none;

  &:hover {
    text-decoration: none;
  }

  &:last-child {
    margin: 0;
  }

  ${SYHeadlineFive} {
    margin-bottom: -${SPACING_BASE * 3}px;
  }
`;

class OnboardingGoalSelectionView extends AbstractView<OnboardingProps> implements ViewInterface {
  +viewName: string = ONBOARDING_GOAL_SELECTION_VIEW_NAME;

  mobileBackgrounds = {
    '1': makeImageUrl({ url: `${CLOUDFRONT_STATIC}/img/backgrounds/onboarding/onboarding-goal-strength-mobile.jpg` }),
    '2': makeImageUrl({ url: `${CLOUDFRONT_STATIC}/img/backgrounds/onboarding/onboarding-goal-mobility-mobile.jpg` }),
    '3': makeImageUrl({ url: `${CLOUDFRONT_STATIC}/img/backgrounds/onboarding/onboarding-goal-skills-mobile.jpg` }),
  };

  onGoalCardClick = (goal: Goal) => {
    const {
      onboardingActions,
      step,
    } = this.props;

    onboardingActions.setUserGoal(goal.id);

    googleTrackingService.trackEvent('funnel', {
      event_category: 'Onboarding',
      event_name: `Step ${step} - ${this.viewName}`,
      event_label: goal.label,
    });
  };

  render() {
    const { step, totalSteps, nextStep } = this.props;

    return (
      <OnboardingContainer>
        <SYProgressBar percentage={(step / totalSteps) * 100} height={1} style={{ marginBottom: SPACING_BASE * 5 }} />
        <SYHeadlineFour>What are we working towards?</SYHeadlineFour>

        {GOALS.map((goal: Goal) => (
          <GoalSelection
            key={`goal-card-ob-${goal.id}`}
            image={this.mobileBackgrounds[goal.id]}
            onClick={() => this.onGoalCardClick(goal)}
            to={nextStep.url}
          >
            <GoalCardHead goal={goal} />
          </GoalSelection>
        ))}
      </OnboardingContainer>
    );
  }
}

export default withOnboarding(OnboardingGoalSelectionView);
